export default __webpack_public_path__ + "static/media/next_property.7c581a20.svg";